package com.devi3east.bashbuddy.features.events.detail.navigation

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.NavType
import androidx.navigation.compose.composable
import androidx.navigation.navArgument
import androidx.navigation.navDeepLink
import androidx.savedstate.read
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.data.api.BASE_URL
import com.devi3east.bashbuddy.features.events.detail.ui.EventDetailRoute

const val EVENT_ID_ARG = "eventId"
const val EVENT_SLUG_ARG = "slug"

/* ---------------------------------------------
   Navigation helper
   --------------------------------------------- */

fun NavController.navigateToEventDetail(
    eventId: String,
    slug: String,
    navOptions: NavOptions? = null
) {
    navigate(
        Screen.EventDetailScreen.createRoute(eventId, slug),
        navOptions
    )
}

/* ---------------------------------------------
   NavGraph definition (KMP-safe + deep-link aware)
   --------------------------------------------- */

fun NavGraphBuilder.eventDetailNavGraph(
    appState: AppState
) {
    composable(
        route = Screen.EventDetailScreen.route,
        arguments = listOf(
            navArgument(EVENT_ID_ARG) {
                type = NavType.StringType
                nullable = false
            },
            navArgument(EVENT_SLUG_ARG) {
                type = NavType.StringType
                nullable = false
            }
        ),
        deepLinks = listOf(
            navDeepLink {
                uriPattern =
                    "{$BASE_URL}/event/{$EVENT_ID_ARG}/{$EVENT_SLUG_ARG}"
            }
        )
    ) { backStackEntry ->

        val args = backStackEntry.arguments ?: return@composable

        val eventId = args.read {
            getString(EVENT_ID_ARG)
        }

        val slug = args.read {
            getString(EVENT_SLUG_ARG)
        }

        EventDetailRoute(
            appState = appState,
            eventId = eventId,
            slug = slug
        )
    }
}